module.exports = __webpack_public_path__ + "img/81.9.TU.a9cf68e6.png";